module.exports = __webpack_public_path__ + "img/xaklogin5.35dc9def.png";